import { useEffect } from 'react';

const CHECK_INTERVAL_MS = 60 * 1000;

const getAssetPaths = (page) => [
  ...Array.from(page.scripts).map((script) => script.src || script.getAttribute('src')),
  ...Array.from(page.querySelectorAll('link[rel="stylesheet"]'))
    .map((link) => link.href || link.getAttribute('href'))
]
  .filter((src) => src && (src.includes('/static/js/') || src.includes('/static/css/')))
  .map((src) => new URL(src).pathname)
  .sort()
  .join('|');

const getLoadedBundles = () => getAssetPaths(document);

const getPublishedBundles = (html) => {
  const page = new DOMParser().parseFromString(html, 'text/html');
  return getAssetPaths(page);
};

export default function useAppUpdater() {
  useEffect(() => {
    let stopped = false;

    const checkForUpdate = async () => {
      try {
        const response = await fetch(`/?update-check=${Date.now()}`, {
          cache: 'no-store',
          headers: { 'Cache-Control': 'no-cache' }
        });
        if (!response.ok || stopped) return;

        const publishedBundles = getPublishedBundles(await response.text());
        const loadedBundles = getLoadedBundles();
        if (publishedBundles && loadedBundles && publishedBundles !== loadedBundles) {
          const url = new URL(window.location.href);
          url.searchParams.set('app-update', Date.now().toString());
          window.location.replace(url.toString());
        }
      } catch {
        // A failed update check should never interfere with the status page.
      }
    };

    checkForUpdate();
    const interval = window.setInterval(checkForUpdate, CHECK_INTERVAL_MS);
    return () => {
      stopped = true;
      window.clearInterval(interval);
    };
  }, []);
}
